import { CustomColumnHeader, CustomColumnItem, ID, LineItem, Lot } from 'types';

export const getOriginalLot = ({
  lotId,
  lots,
}: {
  lotId: ID;
  lots: Lot[];
}): Lot | undefined => (
  lots.find((lot: Lot): boolean => (
    lot.id === lotId
  ))
);

export const getOriginalLineItem = ({
  lineItemId,
  lotId,
  lots,
}: {
  lineItemId: ID;
  lotId: ID;
  lots: Lot[];
}): LineItem | undefined => (
  getOriginalLot({ lotId, lots })
    ?.line_items
    ?.find((lineItem: LineItem): boolean => (
      lineItem.id === lineItemId
    ))
);

export const getOriginalHeader = ({
  headerId,
  lotId,
  lots,
}: {
  headerId: ID;
  lotId: ID;
  lots: Lot[];
}): CustomColumnHeader | undefined => (
  getOriginalLot({ lotId, lots })
    ?.custom_column_headers
    ?.find((header: CustomColumnHeader): boolean => (
      header.id === headerId
    ))
);

export const getOriginalCustomColumnItem = ({
  ccItemId,
  lineItemId,
  lotId,
  lots,
}: {
  ccItemId: ID;
  lineItemId: ID;
  lotId: ID;
  lots: Lot[];
}): CustomColumnItem | undefined => (
  getOriginalLineItem({ lineItemId, lotId, lots })
    ?.custom_column_items
    ?.find((cci: CustomColumnItem): boolean => (
      cci.id === ccItemId
    ))
);
